import { render, staticRenderFns } from "./IsDefaultFor.vue?vue&type=template&id=9e9a4d06&"
import script from "./IsDefaultFor.vue?vue&type=script&lang=js&"
export * from "./IsDefaultFor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports